import { IAction, ActionType, ISetSearchTermAction, setSearchTerm } from '../actions/index';


export function searchTermModel(state: string, action: ISetSearchTermAction) {
    if (typeof state === 'undefined') {
        state = '';
        return state;
    }

    switch (action.type) {
        case ActionType.SET_SEARCH_TERM:
            return setSearchTerm(action.searchTerm).searchTerm;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./App/search-page/reducers/search-term-model.ts